export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
	children: React.ReactNode;
	classnames?: string;
	loading?: boolean;
	withScrollBar?: boolean;
}

export type DefaultCardProps = {
	children: NonNullable<(CardProps['children'])>;
	classnames: NonNullable<(CardProps['classnames'])>;
	loading: NonNullable<(CardProps['loading'])>;
	withScrollBar: NonNullable<(CardProps['withScrollBar'])>;
}

export const defaultProps: CardProps = {
	children: null,
	classnames: "",
	loading: false,
	withScrollBar: false,
};
